@for (result of results(); track result; let i = $index) {
  @if (result.isHeader) {
    <h4 class="quick-search-dropdown-results__title">{{ result.name }}</h4>
  }
  @if (!result.isHeader) {
    <grid-ui-quick-search-dropdown-result
      #searchResult
      class="quick-search-dropdown-results__item"
      [active]="activeIndex === i"
      [disabled]="result.isDisabled"
      [currentIndex]="i"
      [hoverEnabled]="!isScrolling"
      [result]="result"
      (activated)="activate($event)"
      (resultClicked)="resultClicked($event)"
    >
    </grid-ui-quick-search-dropdown-result>
  }
}
